export default __webpack_public_path__ + "22472e74310d9d2e49f6c7fedaf979b7.png";